export type ImportMode = "REPLACE" | "MERGE";

export interface IIftaPerFileValidation {
  quarter: string; // "Q3_2025"
  reported_total_km: number;
  jurisdiction_sum_km: number;
  match: boolean;
  jurisdictions: number;
  surcharge_rows_ignored: number;
  amended: boolean;
  file_name?: string;
}

export interface IIftaImportSummary {
  carrier_name: string | null;
  ifta_account_number: string | null;
  base_jurisdiction: string | null; // "ON"
  quarters_found: string[];
  coverage_period: string | null;
  files: string[]; // S3 keys
  per_file_validation: IIftaPerFileValidation[];
}

export interface IIftaValidationItem {
  key: string; // "DUPLICATE_QUARTER" | ...
  file_name?: string;
  detail: string;
  severity: "error" | "warning";
}

export interface IIftaJurisdictionRow {
  code: string;
  name: string;
  total_km: number;
  pct_of_country: number;
  pct_of_total: number;
  quarterly_km: Record<string, number>;
  source?: "IFTA_IMPORT" | "MANUAL";
}

export interface IIftaQuarterlyRow {
  quarter: string;
  period_start: string;
  period_end: string;
  total_km: number;
  canada_km: number;
  usa_km: number;
  canada_pct: number;
  usa_pct: number;
  pct_of_annual: number;
}

export interface IIftaFilingItem {
  code: string;
  name: string;
  jurisdiction: string;
  reason: string;
  source: "IFTA_IMPORT_RULE" | "MANUAL";
  status: "REQUIRED" | "OPTIONAL" | "WAIVED";
  included?: boolean; // UI toggle state (Requirement 5.7)
}

export interface IIftaProposedSections {
  territory_covered_details: Record<string, any>;
  travel_details: Record<string, any>;
  commodities_details: Record<string, any>;
  list_required_filings: IIftaFilingItem[];
}

export interface IIftaDiffRow {
  path: string;
  from: unknown;
  to: unknown;
}

export interface IIftaImportPreview {
  import_summary: IIftaImportSummary;
  proposed: IIftaProposedSections;
  current: IIftaProposedSections;
  diff: IIftaDiffRow[];
  warnings: IIftaValidationItem[];
  errors: IIftaValidationItem[];
}

export type IftaImportStage =
  | "idle"
  | "uploading"
  | "previewing"
  | "reviewing"
  | "applying"
  | "done"
  | "error";

export interface IIftaImportState {
  stage: IftaImportStage;
  mode: ImportMode;
  files: File[]; // local-only; cleared on close
  preview: IIftaImportPreview | null;
  acknowledgedWarnings: Record<string, boolean>;
  error: string | null;
  previewUnavailable: boolean; // set on HTTP 404 → hide entry points
}

export const initialIftaImportState: IIftaImportState = {
  stage: "idle",
  mode: "REPLACE",
  files: [],
  preview: null,
  acknowledgedWarnings: {},
  error: null,
  previewUnavailable: false,
};
